import {
  TwoStepPaymentFormStep,
  TwoStepPaymentFormStepButton,
  TwoStepPaymentFormStepFooter,
} from 'common/components/entities/two-step-payment-form'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import useTwoStepOptInSubmit from 'publisher/hooks/useTwoStepOptInSubmit'
import React from 'react'
import useManagement, {
  selectors as managementSelectors,
} from '../../../hooks/useManagement'
import BaseNodeChildren from '../../ChildrenEntities'
import FieldErrors from '../../FieldErrors'

export interface OptInStepProps {
  entity: TwoStepPaymentFormStepInterface
  color: string
  mobileColor?: string
  backgroundColor?: string
  mobileBackgroundColor?: string
}

export const TwoStepPaymentFormOptInStep = ({
  entity,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
}: OptInStepProps) => {
  const [isLoading, errors, optInSubmit] = useTwoStepOptInSubmit(entity)
  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <TwoStepPaymentFormStep>
      <BaseNodeChildren childIds={entity.childIds} />
      <TwoStepPaymentFormStepButton
        color={color}
        mobileColor={mobileColor}
        backgroundColor={backgroundColor}
        mobileBackgroundColor={mobileBackgroundColor}
        text={entity.buttonText}
        subText={entity.buttonSubText}
        onClick={optInSubmit as () => void}
        disabled={isLoading || isPreview}
      />
      {/* @ts-ignore errors typing is wrong */}
      <FieldErrors errors={errors} />
      {entity.footerText && (
        <TwoStepPaymentFormStepFooter>
          {entity.footerText}
        </TwoStepPaymentFormStepFooter>
      )}
    </TwoStepPaymentFormStep>
  )
}
